import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import { addAllList } from 'modules/common';

import MbInput from 'components/atoms/MbInput';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  tabContents: {
    maxWidth: 250,
    margin: '0 auto',
    '& > div': {
      marginBottom: 10,
    },
  },
  modalInput: {
    width: '100%',
    '& input': {
      width: '100%',
    },
  },
}));

const ModalCategory = (props) => {
  const {
    tabState,
    modal,
    filterList,
    categoryType,
    refuserTpCode,
    inputError,
    handleModalParams = (f) => f,
    handleModalChange = (f) => f,
    handleFilter = (f) => f,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const codeIsMove = modal.code === 'move';
  return (
    <div className={classes.tabContents}>
      {categoryType !== 'openrtb' ? (
        <FilterCollection
          label={t('카테고리 타입')}
          name="userTpCode"
          value={modal.params.userTpCode}
          type="radio"
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
          params={modal.params}
          list={
            categoryType === 'media'
              ? filterList.userTpCode
              : categoryType === 'campaign' && filterList.campaign
          }
          callBack={handleModalParams}
        />
      ) : null}

      {(codeIsMove || tabState === 'tDepth' || tabState === 'oDepth') &&
        typeof modal.params.userTpCode !== 'undefined' && (
          <FilterCollection
            label={t('1차분류')}
            value={modal.params.hirnkSeq}
            name="hirnkSeq"
            type="select"
            params={modal.params}
            list={addAllList(
              filterList.hirnkSeq,
              'CTGR_NM',
              'CTGR_SEQ',
              'choice'
            )}
            labelKey="CTGR_NM"
            valueKey="CTGR_SEQ"
            callBack={handleModalParams}
            popoverWidth={260}
            popoverHeight={200}
          />
        )}
      {categoryType === 'openrtb' && (
        <MbInput
          useFilter
          name="userTpCode"
          error={inputError.userTpCode}
          inputLabel={t('카테고리 키')}
          onBlur={handleFilter}
          className={classes.modalInput}
        />
      )}
      {filterList.sHirnkSeq.cnt !== 0 &&
        (tabState === 'oDepth' || codeIsMove) && (
          <FilterCollection
            label={t('2차분류')}
            value={modal.params.sHirnkSeq}
            name="sHirnkSeq"
            type="select"
            params={modal.params}
            list={addAllList(
              filterList.sHirnkSeq,
              'CTGR_NM',
              'CTGR_SEQ',
              'choice'
            )}
            labelKey="CTGR_NM"
            valueKey="CTGR_SEQ"
            callBack={handleModalParams}
            popoverWidth={260}
            popoverHeight={200}
          />
        )}
      {!codeIsMove && (
        <MbInput
          useFilter
          name="ctgrNm"
          defaultValue={refuserTpCode.ctgrNm}
          error={inputError.ctgrNm}
          className={classes.modalInput}
          inputLabel="카테고리 이름"
          onBlur={handleModalChange}
        />
      )}
      {categoryType === 'campaign' && modal.tabState === 'oDepth' && (
        <MbInput
          useFilter
          name="sort"
          defaultValue={refuserTpCode.sort}
          error={inputError.sort}
          className={classes.modalInput}
          inputLabel="순서"
          onBlur={handleModalChange}
        />
      )}
    </div>
  );
};
export default ModalCategory;
